import _regeneratorRuntime from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/soutaito/projects/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { ref } from "vue";
import { getData, createData } from "@/services/axios";
import { useStore } from "vue2-helpers/vuex";
import SettingRow from "@/components/dekitus/SettingRow.vue";
import LoadingMessage from "@/components/common/LoadingMessage.vue";
import DekitusIntroduction from "@/components/common/DekitusIntroduction";
export default {
  __name: 'Setting',
  setup: function setup(__props) {
    var dekitusIds = ref([]);
    var dekitusStudents = ref([]);
    var grades = ref([]);
    var dekitusIdUpdate = ref({});
    var isLoading = ref(false);
    var isShowCompleteModal = ref(false);
    var store = useStore();

    var handleStudentChange = function handleStudentChange(data) {
      dekitusIdUpdate.value[data.dekitusId] = data.studentId;
    };

    var handleSubmit = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                isLoading.value = true;
                _context.next = 4;
                return createData("dekitus_student", dekitusIdUpdate.value);

              case 4:
                store.dispatch("commitModalMessage", {
                  message: "学習支援ツールIDの紐づけを登録しました",
                  title: "登録完了"
                });
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                store.dispatch("commitModalMessage", {
                  message: "学習支援ツールIDの紐づけに失敗しました",
                  title: "登録失敗"
                });
                console.log(_context.t0);

              case 11:
                isShowCompleteModal.value = true;
                isLoading.value = false;
                setData();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function handleSubmit() {
        return _ref.apply(this, arguments);
      };
    }();

    var setData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                isLoading.value = true;
                _context2.next = 4;
                return getData(["dekitus_id_stocks", "dekitus_student?with=student.classroom", "grades?with=classroom.student"]);

              case 4:
                data = _context2.sent;

                if (data) {
                  dekitusIds.value = data[0].items[0].dekitus_ids;
                  dekitusStudents.value = data[1].items;
                  grades.value = data[2].items;
                }

                isLoading.value = false;
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                isLoading.value = false;
                console.log(_context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }));

      return function setData() {
        return _ref2.apply(this, arguments);
      };
    }();

    setData();
    return {
      __sfc: true,
      dekitusIds: dekitusIds,
      dekitusStudents: dekitusStudents,
      grades: grades,
      dekitusIdUpdate: dekitusIdUpdate,
      isLoading: isLoading,
      isShowCompleteModal: isShowCompleteModal,
      store: store,
      handleStudentChange: handleStudentChange,
      handleSubmit: handleSubmit,
      setData: setData,
      SettingRow: SettingRow,
      LoadingMessage: LoadingMessage,
      DekitusIntroduction: DekitusIntroduction
    };
  }
};